.composer {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: var(--space-8);
  margin: 0 var(--space-12);
  padding: 6px 6px 6px var(--space-16);
  border: 1px solid var(--w-border-strong);
  border-radius: 22px;
  background: var(--w-bg);
  transition: border-color 120ms ease, box-shadow 160ms ease;
}

.composer:focus-within {
  border-color: var(--w-accent-text);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--w-accent-text) 18%, transparent);
}

.input {
  flex: 1;
  min-height: 36px;
  max-height: 132px;
  padding: 6px 0;
  border: 0;
  background: transparent;
  line-height: 1.5;
  resize: none;
  outline: none;
}

.input::placeholder {
  color: var(--w-faint);
}

.input:focus-visible {
  outline: none;
}

.button {
  display: grid;
  flex: none;
  place-items: center;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 0;
  border-radius: 50%;
  background: var(--w-accent);
  color: var(--w-on-accent);
  cursor: pointer;
  transition: transform 120ms var(--ease-out), opacity 160ms ease, background-color 160ms ease;
}

.button :global(.icon) {
  width: 18px;
  height: 18px;
}

.button:disabled {
  background: var(--w-press);
  color: var(--w-faint);
  cursor: default;
}

.button:active:not(:disabled) {
  transform: scale(0.92);
}

@media (hover: hover) and (pointer: fine) {
  .button:hover:not(:disabled) {
    background: var(--w-accent-strong);
  }
}
